import type { WixRicosViewerProps } from '@wix/ricos';
import { type ComponentType, createContext, useContext } from 'react';

export const WixRicosViewerContext = createContext<
  ComponentType<WixRicosViewerProps> | undefined
>(undefined);

export function useWixRicosViewer() {
  const context = useContext(WixRicosViewerContext);
  if (context === undefined) {
    throw new Error(
      'useWixRicosViewer must be used within a WixRicosViewerContext.Provider',
    );
  }

  return context;
}
